import { createUseData } from "../../../../common/hooks/create-use-data/create-use-data";
import { service } from "./admin-results.service";

export const useAdminAssessmentResults = createUseData(
    service.getAdminResults,
)